import { GeneratedAttachmentResponse } from "@/Common/Api/Attachments/Dto/Responses/GeneratedAttachmentResponse";
import { ExternalEmployeeResponse } from "@/Common/Api/ExternalCommunications/Dto/Responses/ExternalEmployeeResponse";
import { InternalPatientResponse } from "@/Common/Api/ExternalCommunications/Dto/Responses/InternalPatientResponse";
import { AttachedObjectResponse } from "@/Common/Models/FileSelection/Responses/AttachedObject";
import { ExternalPatientResponse } from "@/Communications/Api/Dto/Responses/ExternalPatientResponse";
import { MessageResponse } from "@/Communications/Api/Dto/Responses/MessageResponse";
import { RecipientResponse } from "@/Communications/Api/Dto/Responses/RecipientResponse";

class MessageInfo {
    public message: MessageResponse;
    public recipients: RecipientResponse[];
    public fromEmployee: ExternalEmployeeResponse;
    public patient: ExternalPatientResponse;
    public internalPatient: InternalPatientResponse;
    public attachments: AttachedObjectResponse[];
    public generatedAttachment: GeneratedAttachmentResponse;

    public static fromResponse(response: any): MessageInfo {
        if (!response)
            return null;

        let model = new MessageInfo();
        model.message = response.Message;
        model.fromEmployee = response.FromEmployee;
        model.patient = response.Patient;
        model.internalPatient = response.InternalPatient;
        model.recipients = response.Recipients;
        model.attachments = response.Attachments;
        model.generatedAttachment = response.GeneratedAttachment ? new GeneratedAttachmentResponse(response.GeneratedAttachment) : null;
        return model;
    }
}

export { MessageInfo };
